import React from 'react';
import MaterialIcon from '@/components/MaterialIcon';

const FAQS = [
  {
    question: 'トライアル期間中に料金は発生しますか？',
    answer:
      'いいえ、14日間は完全無料です。クレジットカードの登録も不要です。トライアル終了後、ご希望の場合のみ有料プランをご案内します。',
  },
  {
    question: '導入に必要な準備は何ですか？',
    answer:
      '既存のFAQ資料やWebサイト、PDFがあれば即導入可能です。専用端末は不要で、iPad、PC、またはお客様のスマートフォンで動作します。',
  },
  {
    question: 'トライアル中のサポートはありますか？',
    answer: 'はい、専任の担当者が導入から運用までサポートします。設定方法や活用のコツなど、お気軽にご相談ください。',
  },
];

/**
 * RegisterFAQSection組件
 * 注册页面常见问题展示
 *
 * 显示3个关于试用的常见问题
 */
export const RegisterFAQSection: React.FC = () => {
  return (
    <div className="w-full px-4 md:px-10 lg:px-40 py-16 bg-solution-bg">
      <div className="max-w-[800px] w-full mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl font-black text-solution-text">よくあるご質問</h2>
        </div>

        <div className="space-y-4">
          {FAQS.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl p-6 border border-solution-border">
              <div className="flex items-start gap-4">
                <div className="shrink-0 size-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-black">
                  Q
                </div>
                <div>
                  <h3 className="font-bold text-solution-text mb-2">{faq.question}</h3>
                  <p className="text-solution-text-secondary text-sm">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="/contact"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-solution-orange font-medium hover:underline"
          >
            <span>その他のご質問はお問い合わせください</span>
            <MaterialIcon name="arrow_forward" className="text-lg" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default RegisterFAQSection;
